import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import starsImages from "../../assests/images/star.png";
import { onboardingServices } from "../../services/onboardingServices";
import { vendorServices } from "../../services/vendorServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";

const steps = [
  "Profile",
  "Financial",
  "Factory Visit",
  "Final Rating",
  "3rd Party Validation",
];

function Onboardingstatus() {
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };
  const [progressStep, setProgressStep] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  useEffect(() => {
    getVendorDetails();
  }, []);

  const getVendorDetails = (url) => {
    setIsLoading(true);
    vendorServices
      .getVendorDetails()
      .then(function (response) {
        if (response?.data?.success == true) {
          getFormProgress(response?.data?.data?.vendor?._id);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getFormProgress = (url) => {
    // setIsLoading(true);
    onboardingServices
      .getFormProgress(url)
      .then(function (response) {
        setProgressStep(response.data.data);
      })
      .catch(function (error) {
        // openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        // setIsLoading(false);
      });
  };

  return (
    <div className="onboard_status-outer">
      <div>
        <Box className="lets_onboarding_status_react_bar">
          <Stepper className="lets_onboarding_status_react_bars" activeStep={5} alternativeLabel>

            {progressStep?.progressDetails?.map((label, index) => (
              <Step key={label?.progressName}>
                <div className="text-center">
                  {label?.uniqueName !== 'thirdParty' && (
                    <>
                      {`${label?.rating ? label?.rating : 0}/5 `}
                      <img src={starsImages} alt="" />
                    </>
                  )}

                </div>
                <StepLabel className="lets_onboarding_status_welcome_listings"
                  style={label?.uniqueName === 'thirdParty' ? { marginTop: '24px', paddingLeft: '11px' } : {}} >

                  {label?.progressName}
                </StepLabel>

                <div
                  className="completed_txt"
                  style={{
                    color: label?.status === "Pending" ? "#FC8B07" : "#4F9433",
                  }}
                >
                  {label?.status}
                </div>
                {label?.feedback ? (
                  <div className="received_box">
                    <h5 className="vendor_list_feedback_onboarding">
                      Comment received
                    </h5>
                    <h5>{label?.feedback}</h5>
                  </div>
                ) : <div className="received_box2">

                </div>}
              </Step>
            ))}
          </Stepper>
          <Link className="link_view_vendor" to="/admin/onboarding-from">
            <Button className="view_submit_Details">View Details</Button>
          </Link>
        </Box>
      </div>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div >
  );
}

export default Onboardingstatus;
